import { BlipChat } from 'blip-chat-widget';
import apiUserStatus from '@/services/api-verify-user-status';
import getChatBot from '@/services/setup/get-chat-bot';

export const StartBlip = async () => {
  const userLogged = sessionStorage.getItem('userLogged');

  let statusUser = '';
  if (userLogged) {
    const {
      stName: fullName,
      stEmail: email,
      stDocument: cpf,
    } = JSON.parse(userLogged);

    const hasBlipChat = document.getElementById('blip-chat-container');
    if (!hasBlipChat) {
      const setupChatBot = await getChatBot();
      if (setupChatBot) {
        const blipClient = new BlipChat();

        if (process.env.VUE_APP_CLIENT === 'BAYER') {
          const apiResponse = await apiUserStatus();

          if (apiResponse.RequestResult.AgentStatus.Success) {
            statusUser = apiResponse.RequestResult.AgentStatus.Data;
          }
        }

        blipClient.withAppKey(setupChatBot.chatBotKey)
          .withButton({ color: setupChatBot.skinColorHex, icon: '' })
          .withCustomCommonUrl(setupChatBot.chatBotUrl)
          .withAuth({
            authType: BlipChat.DEV_AUTH,
            userIdentity: email,
            userPassword: email,
          })
          .withAccount({
            fullName: `${fullName}`,
            email: `${email}`,
            extras: {
              cpf: `${cpf}`,
              agentStatus: `${statusUser}`,
            },
          });
        if (setupChatBot.initialText) {
          const messageChat = setupChatBot.initialText
            .replace('{fullName}', fullName)
            .replace('{userDocument}', cpf);

          blipClient.withEventHandler(BlipChat.CREATE_ACCOUNT_EVENT, () => {
            blipClient.sendMessage({
              type: 'text/plain',
              content: messageChat,
            });
          });
        }

        blipClient.build();
        window.setTimeout(() => { document.querySelectorAll<HTMLElement>('#blip-chat-open-iframe').forEach((node) => node.click()); }, 3000);
      }
    }
  }
};

export default StartBlip;
